import { array, literal, union } from 'io-ts/Decoder';

import { Page } from './Page';

export const PagesType = array(Page);

export const Type = union(PagesType, literal('automatic'));
